import {useQuery} from '@tanstack/react-query';
import {apiRequest} from '../utils/AxiosHelper';
import APIs from '../modules/settings/APIs';
import {API_PARAMS} from '../constants/constants';
import {useAppSelector} from "./hooks";
import {UploadFile} from "antd/es/upload/interface";

export interface Attachment extends UploadFile{
  key: string,
  module: string,
  subModule?: string,
  uuid?: string,
  uuidSubEntity?: string,
  data?: string,
  presignedUrl?: string,
}

type AttachmentParams = {
  uid?: string,
  module?: string,
  subModule?: string,
  uuidSubEntity?: string,
}

const fetchAttachments = async (params: AttachmentParams): Promise<Attachment[]> => {
  if (!params.uid) {
    return [];
  }

  const response = await apiRequest.get(APIs.issues.file.list, {
    params: {
      uid: params.uid || API_PARAMS.EMPTY,
      module: params.module || API_PARAMS.EMPTY,
      subModule: params.subModule || API_PARAMS.EMPTY,
      uuidSubEntity: params.uuidSubEntity || API_PARAMS.EMPTY
    }
  });

  const attachments: Attachment[] = response.data || [];

  return attachments.map((att) => {
    if (!att.presignedUrl) return att;
    const isImage = typeof att.type === 'string' && att.type.startsWith('image/');
    return {
      ...att,
      url: att.presignedUrl,
      thumbUrl: isImage ? att.presignedUrl : att.thumbUrl,
    };
  });
};

export const useAttachments = (params: AttachmentParams = {}) => {
  const {isAuthenticated, token} = useAppSelector((state) => state.session);

  return useQuery({
    queryKey: ['attachments', params],
    queryFn: () => fetchAttachments(params),
    enabled: isAuthenticated && !!token && !!params.uid, // Only fetch when authenticated and uid is provided
    staleTime: 0,
    refetchOnMount: "always"
  });
};
